import dayjs from "dayjs";

export function formatDateTime(dateTime: any): string {
    if (!dateTime) return "";
    return dayjs(dateTime).format("DD.MM.YYYY HH:mm:ss");
}
